export const container = (
  borderColor: string,
  backgroundColor: string,
  color: string,
) => ({
  display: 'flex',
  textAlign: 'center',
  fontSize: 12,
  padding: 0,
  border: '1px solid',
  borderColor,
  backgroundColor,
  color,
  borderRadius: '64px',
  paddingY: '2px',
  paddingX: '10px',
  width: 'fit-content',
  gap: '6px',
});

export const icon = (fill: string) => ({
  width: '17px',
  height: '15px',
  paddingTop: '1px',
  fill,
});

export const title = {
  fontSize: '12px',
};
